import Resource from './BaseResource'

class Mov extends Resource {
    constructor(config, tools, version, path) {
        super(config, tools, version, path)
    }
}

export default Mov